export type FeatureFlags = {
  parkingEnabled: boolean;
  htmlAppletsEnabled: boolean;
  reportsEnabled: boolean;
  rssEnabled: boolean;
  pushEnabled: boolean;
  cityDirectoryEnabled: boolean;
  appThemeEnabled: boolean;
  /** Platform SaaS (release profiles / CI) — always on; not tenant-entitlement gated. */
  mobileCiCdEnabled: boolean;
  multiTenancyEnabled: boolean;
};

/** Local defaults; overwritten from GET /api/featureFlags after login. */
export const defaultFeatureFlags: FeatureFlags = {
  parkingEnabled: false,
  htmlAppletsEnabled: true,
  reportsEnabled: true,
  rssEnabled: true,
  pushEnabled: true,
  cityDirectoryEnabled: true,
  appThemeEnabled: true,
  mobileCiCdEnabled: true,
  multiTenancyEnabled: false,
};
